import { render, staticRenderFns } from "./GAccountHeader.vue?vue&type=template&id=671fc5dd&"
import script from "./GAccountHeader.vue?vue&type=script&lang=ts&"
export * from "./GAccountHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports